module.exports = __webpack_public_path__ + "svg/flags/Micronesia, Federated States of.svg";